/** Separate text lines by the largest empty row gaps, ignoring isolated noise. */
export function textInkBands(mask:Uint8Array,width:number,height:number,lines:number):Array<{top:number;bottom:number}>|null {
 const rows:number[]=[];
 for(let y=0;y<height;y++){
  let n=0;for(let x=0;x<width;x++)n+=mask[y*width+x];
  if(n>=Math.max(2,width*0.008))rows.push(y);
 }
 if(!rows.length||lines<1)return null;
 const gaps=rows.slice(1).map((y,i)=>({index:i+1,gap:y-rows[i]-1})).filter(g=>g.gap>0).sort((a,b)=>b.gap-a.gap);
 if(gaps.length<lines-1)return null;
 const cuts=[0,...gaps.slice(0,lines-1).map(g=>g.index).sort((a,b)=>a-b),rows.length];
 return cuts.slice(0,-1).map((start,i)=>({top:rows[start],bottom:rows[cuts[i+1]-1]}));
}
